import { render, staticRenderFns } from "./CreateQuestionnairePage.vue?vue&type=template&id=222a8378&scoped=true&"
import script from "./CreateQuestionnairePage.vue?vue&type=script&lang=ts&"
export * from "./CreateQuestionnairePage.vue?vue&type=script&lang=ts&"
import style0 from "./CreateQuestionnairePage.vue?vue&type=style&index=0&id=222a8378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a8378",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VOverlay,VProgressCircular,VSnackbar})
